<div class="app-container">
  <header class="app-header">
    <a
      class="brand"
      routerLink="/overview/dashboard"
      aria-label="AI Evaluator Overview home"
    >
      <mat-icon class="brand-icon" aria-hidden="true">dashboard</mat-icon>
      <span class="brand-title">AI Evaluator Dashboard</span>
    </a>

    <div class="header-actions">
      @if (isAuthEnabled) {
        @if (isLoggedIn) {
          <button
            mat-icon-button
            (click)="logout()"
            aria-label="Logout"
            matTooltip="Logout"
          >
            <mat-icon>logout</mat-icon>
          </button>
        } @else {
          <button mat-stroked-button (click)="login()" class="login-btn">
            <mat-icon>login</mat-icon>
            Sign in
          </button>
        }
      }
    </div>
  </header>

  <div class="main-content">
    <aside class="side-nav-container" aria-label="Workspace navigation">
      <div class="sidebar-heading">Workspace</div>
      <app-side-nav />
    </aside>
    <main class="content-container">
      <router-outlet />
    </main>
  </div>
</div>
